import http from '@axios'

export default {
  namespaced: true,
  state: {
    user: {
      fullname: undefined,
      premium: false,
    },
    isLoggedIn: false,
    metadataLoaded: false,
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    isPremium: state => state.user.premium,
    showPremiumUpgrade: state => state.metadataLoaded && !(state.isLoggedIn && state.user.premium),
    isCompanyAdmin: state => state.user.iscompanyadmin,
    companyStatus: state => state.user.companystatus,
    portfolioMax: state => state.user.portfoliomax,
    portfolioMaxProducts: state => state.user.portfoliomaxproducts,
    usersFullName: state => state.user.fullname,
    filterSelectionMax: state => state.user.filterselectionmax,
    virtualPortfolioRunsLimit: state => state.user.virtualportfoliorunslimit,
  },
  mutations: {
    RESET_STATE(state) {
      state.isLoggedIn = false
      state.user = {
        premium: false,
      }
    },
  },
  actions: {
    getUserMetadata({ state, dispatch }) {
      return http.get('auth.cfc?method=getUserMetadata')
        .then(response => {
          const { data } = response
          if (data.loggedIn) {
            state.isLoggedIn = true
            state.user = data.user
            dispatch('app/updateRunsCounts', null, { root: true })
            return dispatch('app/updatePortfolios', null, { root: true })
          }
          return null
        })
        .catch(() => {})
        .finally(() => { state.metadataLoaded = true })
    },
    logout({ commit }) {
      return http.get('auth.cfc?method=logoutUser')
        .then(response => {
          if (response.status === 204) {
            commit('RESET_STATE')
          }
        })
    },
  },
}
